/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectStatusResponseDto
 */
export interface ConnectStatusResponseDto {
    /**
     * Whether the practice has a Stripe Connect account created (but not necessarily onboarded)
     * @type {boolean}
     * @memberof ConnectStatusResponseDto
     */
    hasAccount: boolean;
    /**
     * Whether the practice has completed onboarding (submitted all required details)
     * @type {boolean}
     * @memberof ConnectStatusResponseDto
     */
    isOnboarded: boolean;
    /**
     * Whether the practice can receive payouts
     * @type {boolean}
     * @memberof ConnectStatusResponseDto
     */
    canReceivePayouts: boolean;
    /**
     * Whether charges are enabled for this account
     * @type {boolean}
     * @memberof ConnectStatusResponseDto
     */
    chargesEnabled: boolean;
    /**
     * Requirements currently due (must be completed before payouts enabled)
     * @type {Array<string>}
     * @memberof ConnectStatusResponseDto
     */
    requirementsCurrentlyDue: Array<string>;
    /**
     * Requirements that will eventually be due
     * @type {Array<string>}
     * @memberof ConnectStatusResponseDto
     */
    requirementsEventuallyDue: Array<string>;
    /**
     * Stripe Connect account ID (if exists)
     * @type {string}
     * @memberof ConnectStatusResponseDto
     */
    accountId: string | null;
}

/**
 * Check if a given object implements the ConnectStatusResponseDto interface.
 */
export function instanceOfConnectStatusResponseDto(value: object): value is ConnectStatusResponseDto {
    if (!('hasAccount' in value) || value['hasAccount'] === undefined) return false;
    if (!('isOnboarded' in value) || value['isOnboarded'] === undefined) return false;
    if (!('canReceivePayouts' in value) || value['canReceivePayouts'] === undefined) return false;
    if (!('chargesEnabled' in value) || value['chargesEnabled'] === undefined) return false;
    if (!('requirementsCurrentlyDue' in value) || value['requirementsCurrentlyDue'] === undefined) return false;
    if (!('requirementsEventuallyDue' in value) || value['requirementsEventuallyDue'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function ConnectStatusResponseDtoFromJSON(json: any): ConnectStatusResponseDto {
    return ConnectStatusResponseDtoFromJSONTyped(json, false);
}

export function ConnectStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasAccount': json['hasAccount'],
        'isOnboarded': json['isOnboarded'],
        'canReceivePayouts': json['canReceivePayouts'],
        'chargesEnabled': json['chargesEnabled'],
        'requirementsCurrentlyDue': json['requirementsCurrentlyDue'],
        'requirementsEventuallyDue': json['requirementsEventuallyDue'],
        'accountId': json['accountId'],
    };
}

export function ConnectStatusResponseDtoToJSON(json: any): ConnectStatusResponseDto {
    return ConnectStatusResponseDtoToJSONTyped(json, false);
}

export function ConnectStatusResponseDtoToJSONTyped(value?: ConnectStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasAccount': value['hasAccount'],
        'isOnboarded': value['isOnboarded'],
        'canReceivePayouts': value['canReceivePayouts'],
        'chargesEnabled': value['chargesEnabled'],
        'requirementsCurrentlyDue': value['requirementsCurrentlyDue'],
        'requirementsEventuallyDue': value['requirementsEventuallyDue'],
        'accountId': value['accountId'],
    };
}

